/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.activityLog', [])
    .factory('activityLogService', ActivityLogService)
    .name;

/*@ngInject*/
function ActivityLogService($http, $q) {
    var canceller;

    return {
        getUserActivityLog: getUserActivityLog,
        cancelFetchingActivityLog: cancelFetchingActivityLog
    };
    function getUserActivityLog(providerTitle, customerTitle, entityTypes, entityId, entityEUI, entityName, userEmail, userIpAddress, activities, description, startTs, endTs, limit, page, sortField, sortOrder, selectTotalCount) {
        var deferred = $q.defer();
        canceller = deferred;
        var url = `/api/userActivityLog/?startTs=${startTs}&limit=${limit}&page=${page}`;

        if (providerTitle) {
            url += `&providerTitle=${encodeURIComponent(providerTitle)}`;
        }
        if (customerTitle) {
            url += `&customerTitle=${encodeURIComponent(customerTitle)}`;
        }
        if (entityTypes && entityTypes.length) {
            url += `&entityType=${entityTypes.join(',')}`;
        }
        if (entityId) {
            url += `&entityId=${encodeURIComponent(entityId)}`;
        }
        if (entityEUI) {
            url += `&entityMetaId=${encodeURIComponent(entityEUI)}`;
        }
        if (entityName) {
            url += `&entityMetaName=${encodeURIComponent(entityName)}`;
        }
        if (userEmail) {
            url += `&userEmail=${encodeURIComponent(userEmail)}`;
        }
        if (userIpAddress) {
            url += `&userIpAddress=${encodeURIComponent(userIpAddress)}`;
        }
        if (activities && activities.length) {
            url += `&activity=${activities.join(',')}`;
        }
        if (description) {
            url += `&description=${encodeURIComponent(description)}`;
        }
        if (endTs) {
            url += `&endTs=${endTs}`;
        }
        if (sortField) {
            url += `&sortField=${sortField}`;
        }
        if (sortOrder) {
            url += `&sortOrder=${sortOrder}`;
        }
        if (selectTotalCount) {
            url += `&selectTotalCount=${selectTotalCount}`;
        }

        $http.get(url, {timeout: deferred.promise}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function cancelFetchingActivityLog() {
        canceller.resolve();
    }

}



// WEBPACK FOOTER //
// ./src/app/api/activity-log.service.js